var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { color, fontFamily, fontSize, fontWeight, spacing } from '../Styles/Base';
import PartiText from './PartiText';
var Pill = function (_a) {
    var value = _a.value, _b = _a.onPress, onPress = _b === void 0 ? null : _b, containerStyle = _a.containerStyle, textStyle = _a.textStyle;
    var combinedTextStyle = __assign(__assign({}, styles.text), textStyle);
    return (React.createElement(View, { style: [styles.pill, containerStyle] },
        React.createElement(PartiText, { style: combinedTextStyle, onPress: onPress }, value)));
};
var styles = StyleSheet.create({
    text: {
        color: color.white,
        fontSize: fontSize.small,
        fontFamily: fontFamily.title,
        fontWeight: fontWeight.bold,
        textAlign: 'center',
    },
    pill: {
        alignSelf: 'flex-start',
        borderRadius: 14,
        overflow: 'hidden',
        paddingVertical: spacing.extraSmall,
        paddingHorizontal: spacing.medium,
    },
});
export default Pill;
